import { useEffect } from "react";

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | Agent Book CRM` : "Agent Book CRM";

    return () => {
      document.title = "Agent Book CRM";
    };
  }, [title]);
};

export default usePageTitle;